module.exports = __webpack_public_path__ + "static/media/acerta-thumbsup.52ac1b86.svg";